
import React from "react";
import { Separator } from "@/components/ui/separator";
import { Card, CardContent } from "@/components/ui/card";

const SerialAcquisitionPage: React.FC = () => {
  return (
    <div className="bg-white min-h-screen p-6">
      <div className="max-w-7xl mx-auto">
        <h1 className="text-3xl font-bold text-noa-rich-black mb-6">
          Serial Acquisition VMS HoldCo
        </h1>
        <Separator className="mb-8 bg-gray-200" />
        
        <div className="mb-16">
          <h2 className="text-2xl font-bold text-noa-rich-black mb-2 whitespace-nowrap">
            The Last Great Frontier for VMS Consolidation: LatAm's Inflection Moment
          </h2>
          <h3 className="text-xl font-semibold text-noa-rich-black mb-2">
            <span className="bg-blue-500 text-white px-2 py-1 rounded mr-1">Past</span> Global Acquirers Stayed Away
          </h3>
          <h3 className="text-xl font-semibold text-noa-rich-black mb-6">— High Prices, Loose Governance, Complex Deals</h3>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
            <Card className="bg-gray-50 border-gray-200 hover:shadow-md transition-shadow duration-300">
              <CardContent className="pt-5 p-5">
                <h4 className="text-base font-bold text-noa-rich-black mb-2">Opaque Market</h4>
                <p className="text-sm text-gray-600">
                  No clear databases, few intermediaries, and limited visibility into targets.
                </p>
              </CardContent>
            </Card>
            
            <Card className="bg-gray-50 border-gray-200 hover:shadow-md transition-shadow duration-300">
              <CardContent className="pt-5 p-5">
                <h4 className="text-base font-bold text-noa-rich-black mb-2">Governance Gaps in LatAm</h4>
                <p className="text-sm text-gray-600">
                  Informality, tax schemes, and weak financials increased deal risk.
                </p>
              </CardContent>
            </Card>
            
            <Card className="bg-gray-50 border-gray-200 hover:shadow-md transition-shadow duration-300">
              <CardContent className="pt-5 p-5">
                <h4 className="text-base font-bold text-noa-rich-black mb-2">Unrealistic Valuation Expectations</h4>
                <p className="text-sm text-gray-600">
                  Sellers demanded high multiples, ignoring adjusted free cash flow.
                </p>
              </CardContent>
            </Card>
            
            <Card className="bg-gray-50 border-gray-200 hover:shadow-md transition-shadow duration-300">
              <CardContent className="pt-5 p-5">
                <h4 className="text-base font-bold text-noa-rich-black mb-2">Founders Not Ready to Exit</h4>
                <p className="text-sm text-gray-600">
                  Most (in their 40s–50s) were still scaling—exit was not top of mind.
                </p>
              </CardContent>
            </Card>
          </div>
        </div>
        
        <div className="bg-red-50 border border-red-200 p-3 rounded-lg w-full text-center mb-6">
          <p className="text-base font-semibold text-red-800">LatAm Inflection Point — Conditions Now Favor Consolidation</p>
        </div>
        
        <div className="mb-16">
          <h3 className="text-xl font-semibold text-noa-rich-black mb-2">
            <span className="bg-blue-500 text-white px-2 py-1 rounded mr-1">Now</span> Growing Base of Acquisition-Ready Targets
          </h3>
          <h3 className="text-xl font-semibold text-noa-rich-black mb-6">— Clean Books, Committed Sellers, Attractive Multiples</h3>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
            <Card className="bg-blue-50/50 border-blue-200 hover:shadow-md transition-shadow duration-300">
              <CardContent className="pt-5 p-5">
                <h4 className="text-base font-bold text-noa-rich-black mb-2">Stricter Tax & Legal Enforcement</h4>
                <p className="text-sm text-gray-600">
                  Governments are formalizing books and aligning reporting to GAAP/IFRS.
                </p>
              </CardContent>
            </Card>
            
            <Card className="bg-blue-50/50 border-blue-200 hover:shadow-md transition-shadow duration-300">
              <CardContent className="pt-5 p-5">
                <h4 className="text-base font-bold text-noa-rich-black mb-2">Aging Founders — Exit Ready</h4>
                <p className="text-sm text-gray-600">
                  First-gen VMS owners are entering retirement and succession phase.
                </p>
              </CardContent>
            </Card>
            
            <Card className="bg-blue-50/50 border-blue-200 hover:shadow-md transition-shadow duration-300">
              <CardContent className="pt-5 p-5">
                <h4 className="text-base font-bold text-noa-rich-black mb-2">Post-COVID Digitization Boom</h4>
                <p className="text-sm text-gray-600">
                  SaaS adoption surged; many vendors now at $2–5M ARR with solid infrastructure.
                </p>
              </CardContent>
            </Card>
            
            <Card className="bg-blue-50/50 border-blue-200 hover:shadow-md transition-shadow duration-300">
              <CardContent className="pt-5 p-5">
                <h4 className="text-base font-bold text-noa-rich-black mb-2">Valuations Now Reasonable</h4>
                <p className="text-sm text-gray-600">5–7x EBITDA multiples; fewer sellers anchor to inflated tax-optimized cash flow.
                </p>
              </CardContent>
            </Card>
          </div>
          
          <div className="bg-green-50 border border-green-200 p-3 rounded-lg w-full text-center mt-6">
            <p className="text-base font-semibold text-green-800">Sellers Prefer Local Buyers — In LatAm, Trust Beats Global Capital</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SerialAcquisitionPage;
